import { helper } from '@ember/component/helper';

import { get } from 'rise-ui/utils/object.js';

export default helper(function getByHelper(args) {
  return (...moreArgs) => {
    const [ key, obj ] = [ ...args, ...moreArgs ];
    if (obj) {
      return get(obj, key);
    }
  };
});
